/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantPublicGradingSettingsEvalDimensions } from './tenantPublicGradingSettingsEvalDimensions';
import type { PerformanceLevelConfig } from './performanceLevelConfig';
import type { TenantPublicGradingSettingsGradeProjector } from './tenantPublicGradingSettingsGradeProjector';
import type { TenantPublicGradingSettingsTaskGradeProjectors } from './tenantPublicGradingSettingsTaskGradeProjectors';

/**
 * Public grading settings for tenants that should be available before login
 */
export interface TenantPublicGradingSettings {
  /** Dictionary of evaluation dimensions with their configurations including weights */
  evalDimensions?: TenantPublicGradingSettingsEvalDimensions;
  /** List of performance level configurations */
  performanceLevels?: PerformanceLevelConfig[];
  oralExamDimensionKeys?: string[];
  gradeProjector?: TenantPublicGradingSettingsGradeProjector;
  taskGradeProjectors?: TenantPublicGradingSettingsTaskGradeProjectors;
}
